import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  PageInteractionsRecommendationsForm,
  PageInteractionsRecommendationsProps,
} from './PageInteractionsRecommendationsForm';
import { Namespace } from '../../../../translation/namespace';
import useCollapsibleOverlay from '../../../../hooks/useCollapsibleOverlay';
import Btn from '../../../../components/molecules/Btn';
import { Icons } from '../../../../components/atoms/SVG';
import { CollapsibleContent } from '../../../../components/organisms/CollapsibleOverlay/CollapsibleOverlay';
import { CollapsibleModifier } from '../../../../components/organisms/CollapsibleOverlay/CollapsibleOverlay.modifier';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';

export function PageInteractionsRecommendationButton({ form }: { form: PageInteractionsRecommendationsProps['form'] }) {
  const { t } = useTranslation(Namespace.PageInteractions);
  const { closeCollapsible, collapsibleOpen, collapsibleProps, toggleProps } = useCollapsibleOverlay();

  return (
    <div className="page-interactions__button-container">
      <Btn
        type="button"
        cssClass="btn--minor-action btn--transparent"
        svgSpriteId={collapsibleOpen ? Icons.DECLINE_CROSS : Icons.RECOMMEND_PAPERPLANE}
        ariaControls={toggleProps['aria-controls']}
        ariaExpanded={toggleProps['aria-expanded']}
        hiddenText
        text={t(`recommendation.buttonText`)}
        titleText={t(`recommendation.buttonTitleText`)}
        tooltipPlacement={TooltipPlacement.TOP}
        onClick={toggleProps.onClick}
        onKeyDown={toggleProps.onKeyDown}
        reference={toggleProps.ref}
      />
      <CollapsibleContent {...collapsibleProps} modifier={CollapsibleModifier.PAGE_INTERACTIONS}>
        <PageInteractionsRecommendationsForm form={form} closeCollapsible={closeCollapsible} />
      </CollapsibleContent>
    </div>
  );
}
